import styled from 'styled-components'

import { Trend } from '@root/entities/trend/model'
import { CountMax3DigitsFormatted } from '@root/shared/core/format'

import type { Maker } from '@root/entities/trade'
import type { ClassNameProps } from '@root/shared/react'

export type TableMakerCellProps = {
  maker: Maker.MakerShort
} & ClassNameProps

export const TableMakerCellTxs: React.FC<TableMakerCellProps> = ({
  maker,
  className,
}) => {
  const pnl = maker.pnl
  const pnlTrend = Trend.of(pnl)

  return (
    <Root data-trend={pnlTrend} className={className}>
      <CountMax3DigitsFormatted count={maker.txCount} />
    </Root>
  )
}

const Root = styled.div`
  display: grid;
  align-content: center;
  justify-content: center;

  min-width: 20px;
  height: 20px;
  padding-inline: 4px;

  border-radius: 6px;
  background: var(--backgroundA-3);
  border: 1px solid var(--background-3);

  color: var(--text-9);
  text-align: center;
  font-family: Inter;
  font-size: 11px;
  font-weight: 700;

  &[data-trend='up'] {
    background: var(--upA-3);
    border-color: var(--upA-5);
    color: var(--up-10);
  }
  &[data-trend='down'] {
    background: var(--downA-3);
    border-color: var(--downA-5);
    color: var(--down-10);
  }
`
